<template>
   <div class="tax-information-bubble">
      <div class="tax-information-header">{{ title }}</div>
      <div class="tax-information-grid">
         <div v-for="(policies, category) in sortedMetaPolicy" :key="category" class="policy-category">
            <h2>{{ $t(category) }}</h2>
            <div v-for="(policy, index) in policies" :key="index" class="policy-item">
               <div v-for="(value, key) in mergeDescription(policy)" :key="key" class="policy-detail">
                  <strong>{{ labelHandler(category, key) }}:</strong>
                  <span>{{ value }}</span>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "MetaPolicyModal",
   props: {
      title: { type: String },
      metaPolicy: { type: Object, default: () => ({}) },
   },
   data() {
      return {};
   },
   computed: {
      sortedMetaPolicy() {
         if (!this.metaPolicy) return {};
         const entries = Object.entries(this.metaPolicy);
         entries.sort(([, policiesA], [, policiesB]) => policiesA.length - policiesB.length);
         return Object.fromEntries(entries);
      },
   },
   methods: {
      mergeDescription(policy) {
         const { description, ...rest } = policy;
         const mergedPolicy = { ...rest, ...description };
         if (mergedPolicy.type === null) {
            delete mergedPolicy.type;
         }
         return mergedPolicy;
      },
      labelHandler(category, key) {
         const categoryLabel = category.split("_")[1];
         const keyLabel = key.split("_")[1] == undefined ? key : key.split("_")[1];
         return this.$t(`${categoryLabel}_${keyLabel}`);
      },
   },
};
</script>

<style lang="scss" scoped>
.tax-information-bubble {
   position: absolute;
   right: 0px;
   left: 0px;
   margin: auto;
   z-index: 1000;
   height: fit-content;
   background-color: var(--gray-700);
   //color: var(--gray-50);
   color: var(--gray-0);
   width: 800px;
   padding: 1rem;
   border-radius: 8px;
}

.tax-information-header {
   font-weight: bold;
   margin-bottom: 0.75rem;
   font-size: 1rem;
}

.tax-information-grid {
   display: grid;
   grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
   gap: 0.5rem;
   height: 400px;
   overflow-y: auto;
}

.tax-information-grid::-webkit-scrollbar {
   width: 12px;
}

.tax-information-grid::-webkit-scrollbar-track {
   background: var(--gray-800);
   border-radius: 10px;
}

.tax-information-grid::-webkit-scrollbar-thumb {
   background-color: var(--gray-500);
   border-radius: 10px;
   border: 3px solid var(--gray-800);
}

.policy-category {
   background-color: var(--gray-600);
   padding: 1rem;
   border-radius: 8px;
}

.policy-item {
   margin-bottom: 1rem;
   padding: 0.5rem;
   background-color: var(--gray-500);
   border-radius: 4px;
}

.policy-detail {
   display: flex;
   justify-content: space-between;
   margin-bottom: 0.5rem;
   font-size: 0.75rem;
}

.policy-detail strong {
   //color: var(--gray-50);
   color: var(--gray-0);
   margin-right: 0.5rem;
}

.description-detail {
   display: flex;
   justify-content: space-between;
   margin-bottom: 0.25rem;
   font-size: 0.75rem;
   //color: var(--gray-50);
   color: var(--gray-0);
}

.description-detail strong {
   margin-right: 0.25rem;
}
</style>
